import { Installation } from "../Installation";
import { InstalledSoftware } from "../InstalledSoftware";
import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";

export class InstallationCaosConfiguration extends Installation {
    lastBackup: Date;
    caosConfigurationVersion: string;
    agent: Array<InstalledSoftware> = null;

    public parse(obj: any) {
        super.parse(obj);
        if (obj.LastBackup) this.lastBackup = obj.LastBackup;
        if (obj.CaosConfigurationVersion) this.caosConfigurationVersion = obj.CaosConfigurationVersion;
        if (obj.AgentInfo && obj.AgentInfo.Version) {
            this.agent = new Array<InstalledSoftware>();
            let agentSoftware = new InstalledSoftware();
            agentSoftware.name = "Agent";
            agentSoftware.version = obj.AgentInfo.Version;
            agentSoftware.updateType = UpdateTypeEnum.Agent;
            this.agent.push(agentSoftware);
        }
    }
}
